<template>
    <div class="answer-outter">
        <answer-reply
            v-if="answerModel.reply && !answerModel.reply.empty && h5ConfigData.ttsConfiguration !== 3"
            class="answer-wrap"
            :h5ConfigData="h5ConfigData"
            :reply="answerModel.reply"
            :owner="owner"
            @setPreviewImg="setPreviewImg"
        ></answer-reply>
        <answer-reply
            v-if="answerModel.objective && !answerModel.objective.empty && h5ConfigData.ttsConfiguration !== 3"
            class="answer-wrap"
            :h5ConfigData="h5ConfigData"
            :reply="answerModel.objective"
            :owner="owner"
            @setPreviewImg="setPreviewImg"
        ></answer-reply>
        <answer-recommend
            v-if="answerModel.recommend && answerModel.recommend.Items.length && h5ConfigData.ttsConfiguration !== 3"
            class="answer-wrap"
            :h5ConfigData="h5ConfigData"
            :answerModel="answerModel"
            :owner="owner"
            @changeInput="changeInput"
        ></answer-recommend>
        <!-- 常见问题 -->
        <answer-faq
            v-if="answerModel.com && answerModel.com === 'faq' && (answerModel.faqs.length > 0 || answerModel.menu.length > 0)"
            class="answer-wrap"
            :h5ConfigData="h5ConfigData"
            :owner="owner"
            :faqs="answerModel.faqs"
            :menu="answerModel.menu"
            :title="title"
            @changeInput="changeInput"
        ></answer-faq>
        <answer-askback
            v-if="answerModel.backask && answerModel.backask.Items.length && owner === 'SJTU'"
            class="answer-wrap"
            :h5ConfigData="h5ConfigData"
            :answerModel="answerModel"
            :owner="owner"
            @changeInput="changeInput"
        ></answer-askback>
        <answer-askback
            v-if="answerModel.backask && answerModel.backask.Items.length && h5ConfigData.ttsConfiguration !== 3 && owner !== 'SJTU'"
            class="answer-wrap"
            :h5ConfigData="h5ConfigData"
            :answerModel="answerModel"
            :owner="owner"
            @changeInput="changeInput"
        ></answer-askback>
        <answer-tts
            v-if="answerModel.ttsUrl"
            class="answer-wrap"
            :h5ConfigData="h5ConfigData"
            :answerModel="answerModel"
            :curAudioSrc="curAudioSrc"
            :owner="owner"
            @setCurAudioSrc="setCurAudioSrc"
        ></answer-tts>
        <template v-if="answerModel.reply && !answerModel.reply.empty">
            <answer-music
                v-for="(item, index) in answerModel.reply.Items"
                :key="index.toString()"
                class="answer-wrap"
                :h5ConfigData="h5ConfigData"
                :answerItem="item"
                :curAudioSrc="curAudioSrc"
                :owner="owner"
                @setCurAudioSrc="setCurAudioSrc"
            ></answer-music>
        </template>
        <a v-if="h5ConfigData.adFlag && adDialogue === h5ConfigData.adDialogue" target="_blank" :href="h5ConfigData.adLink" class="simulator-ad">
            <div :style="{ 'background-image': `url(${h5ConfigData.adImage})` }"></div>
        </a>
    </div>
</template>

<script>
import AnswerReply from './AnswerReply.vue'
import AnswerRecommend from './AnswerRecommend.vue'
import AnswerAskback from './AnswerAskback.vue'
import AnswerTts from './AnswerTts.vue'
import AnswerMusic from './AnswerMusic.vue'
import AnswerFaq from './AnswerFaq.vue'

export default {
  props: {
    h5ConfigData: {
      type: Object
    },

    adDialogue: {
      type: Number
    },

    answerModel: {
      type: Object
    },

    previewImg: {
      type: String
    },

    curAudioSrc: {
      type: String
    },
    owner: {
      type: String
    },
    title: {
      type: String
    }
  },

  components: {
    AnswerReply,
    AnswerRecommend,
    AnswerAskback,
    AnswerTts,
    AnswerMusic,
    AnswerFaq
  },

  methods: {
    setPreviewImg (picUrl) {
      this.$emit('update:previewImg', picUrl)
    },

    changeInput (val) {
      this.$emit('changeInput', val)
    },

    setCurAudioSrc (type, val = '') {
      this.$emit('setCurAudioSrc', type, val)
    }
  }
}
</script>

<style lang="scss" scoped>
.answer {
    &-outter {
        &:first-child {
            > div {
                margin-top: 0;
            }
        }
    }

    &-wrap {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        margin-top: 44px;
    }
}

.simulator-ad {
    display: block;
    margin-top: 32px;
    height: 104px;
    background: linear-gradient(135deg, rgba(48, 35, 174, 1) 0%, rgba(200, 109, 215, 1) 100%);

    div {
        height: 100%;
        background: linear-gradient(135deg, rgba(48, 35, 174, 1) 0%, rgba(200, 109, 215, 1) 100%) no-repeat center center;
        background-size: cover;
    }
}
</style>



// WEBPACK FOOTER //
// src/app/GenH5/Answer/index.vue